import { createMuiTheme, makeStyles } from '@material-ui/core';
import { lightBlue, orange } from '@material-ui/core/colors';
export const drawerWidth = 240;

// The colors for the dark palette
export const themeDark = createMuiTheme({
  palette: {
    // @ts-ignore
    type: 'dark',
    primary: lightBlue,
    secondary: orange,
    background: {
      default: '#202327',
      paper: '#292D32',
    },
    steicolors: {
      darkside: '#263479',
      midside: '#1C4A88',
      lightside: '#13639A',
    },
  },
});

// The colors for the light palette
export const themeLight = createMuiTheme({
  palette: {
    // @ts-ignore
    type: 'light',
    primary: lightBlue,
    secondary: orange,
    background: {
      paper: '#F4F3F2',
      default: '#EFEDEC',
    },
    steicolors: {
      darkside: '#29388F',
      midside: '#146BB3',
      lightside: '#1075BA',
    },
  },
});

// Site-wide classes/styles for the dark theme
export const rootStylesDark = makeStyles(() => ({
  root: {
    '& .MuiButton-contained': {
      background:
        'linear-gradient(25deg, ' +
        themeDark.palette.steicolors.darkside +
        ' 0%, ' +
        themeDark.palette.steicolors.lightside +
        ' 100%)',

      color: '#e0e0e0',
      '&:hover': {
        color: orange[300],
      },
      '&:disabled': {
        background:
          'linear-gradient(25deg, ' +
          themeLight.palette.steicolors.darkside +
          '60' +
          ' 0%, ' +
          themeLight.palette.steicolors.lightside +
          '60' +
          ' 100%)',
      },
    },
  },
}));

// Site-wide classes/styles for the light theme
export const rootStylesLight = makeStyles(() => ({
  root: {
    '& .MuiButton-contained': {
      background:
        'linear-gradient(25deg, ' +
        themeLight.palette.steicolors.darkside +
        ' 0%, ' +
        themeLight.palette.steicolors.lightside +
        ' 100%)',

      color: '#e0e0e0',
      '&:hover': {
        color: orange[300],
      },
      '&:disabled': {
        background:
          'linear-gradient(25deg, ' +
          themeLight.palette.steicolors.darkside +
          '60' +
          ' 0%, ' +
          themeLight.palette.steicolors.lightside +
          '60' +
          ' 100%)',
      },
    },
  },
}));

// Site-wide classes/styles for any and all theme (mostly deals with sizes and positions instead of colors)
export const mainishStyles = makeStyles((theme) => ({
  formCommons: {
    '& .MuiTextField-root': {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    '& .MuiFormControl-root': {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    '& .MuiButtonBase-root': {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    '& .MuiAutocomplete-endAdornment': {
      marginTop: theme.spacing(-2),
      marginBottom: theme.spacing(-2),
    },
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    [theme.breakpoints.up('md')]: { padding: theme.spacing(3) },
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    minWidth: 280,
    // marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },

  pageContent: {
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(5),
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down('xs')]: {
      // margin: theme.spacing(5),
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5),
      padding: theme.spacing(2),
    },
  },
  footer: {
    // flexGrow: 1,
    // padding: theme.spacing(3),
    width: `100%`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    // marginLeft: -drawerWidth,
  },
  footerShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },
  actionDivBoxOuter: {
    width: '100%',
    display: 'flex',
  },
  actionDivBoxLeft: {
    display: 'flex',
    marginRight: 'auto',
    marginLeft: 0,
  },
  actionDivBoxRight: {
    display: 'flex',
    marginRight: 0,
    marginLeft: 'auto',
  },
}));
